import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Mail, Copy, Check } from 'lucide-react'

export function Contact() {
  const [copied, setCopied] = useState(false)
  const email = 'support@vaultlynk.com'

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard API not available
    }
  }

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4 py-12">
      <Helmet>
        <title>Contact | VaultLynk</title>
        <meta name="description" content="Get in touch with the VaultLynk team. We typically respond within 24 hours." />
      </Helmet>
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Mail className="w-8 h-8 text-primary-600" />
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">Get in Touch</h1>

        <p className="text-gray-600 mb-8">
          Have questions, feedback, or need help? We'd love to hear from you.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={`mailto:${email}`}
            className="inline-flex items-center justify-center px-6 py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Mail className="w-5 h-5 mr-2" />
            Send Email
          </a>

          <button
            onClick={copyEmail}
            className="inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors"
          >
            {copied ? (
              <>
                <Check className="w-5 h-5 mr-2 text-green-600" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-5 h-5 mr-2" />
                Copy Email
              </>
            )}
          </button>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          {email}
        </p>

        <p className="text-sm text-gray-400 mt-2">
          We typically respond within 24 hours.
        </p>
      </div>
    </div>
  )
}
